import { render, staticRenderFns } from "./OtherMarketInstrumentsLogs.vue?vue&type=template&id=78bd5142&scoped=true"
import script from "./OtherMarketInstrumentsLogs.vue?vue&type=script&lang=js"
export * from "./OtherMarketInstrumentsLogs.vue?vue&type=script&lang=js"
import style0 from "./OtherMarketInstrumentsLogs.vue?vue&type=style&index=0&id=78bd5142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd5142",
  null
  
)

export default component.exports